import { render, staticRenderFns } from "./AscNoData.vue?vue&type=template&id=07508544&"
import script from "./AscNoData.vue?vue&type=script&lang=js&"
export * from "./AscNoData.vue?vue&type=script&lang=js&"
import style0 from "./AscNoData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports